module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 4.a771f88.svg";